import React, { useEffect, useState, useCallback } from 'react';
import { LayoutDashboard, Maximize2 } from 'lucide-react';
import { BarChart, Bar, ResponsiveContainer } from 'recharts';
import FaturamentoTotal from './FaturamentoTotal';

const MiniChart = ({ color }) => {
  const data = Array.from({ length: 10 }, () => ({ val: Math.random() * 100 }));
  return (
    <div className="h-8 w-20 opacity-30">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <Bar dataKey="val" fill={color} radius={[1, 1, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

function StatBox({ title, icon: Icon, color, border, dia, mes, hasMeta, metaVal, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      {/* Botão de Expansão */}
      <button 
        onClick={onExpand}
        className="absolute top-3 right-3 text-gray-600 hover:text-green-400 transition-colors z-20"
      >
        <Maximize2 size={18} />
      </button>

      <div className={`flex items-center gap-2 mb-6 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={14} /> <span>{title}</span>
      </div>

      <div className="flex justify-between items-end mb-4">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Dia</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            R$ {Number(dia).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <MiniChart color="#4ade80" />
      </div>

      <div className="border-t border-gray-800 pt-3">
        <div className="flex justify-between items-center">
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Mês</p>
          <p className={`${color} font-mono text-lg font-bold italic tracking-tighter`}>
            R$ {Number(mes).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        {hasMeta && (
          <div className="w-full bg-gray-900 h-1 rounded-full overflow-hidden mt-3">
            <div 
              className="bg-green-500 h-full shadow-[0_0_8px_#22c55e]" 
              style={{ width: `${metaVal || 0}%` }} 
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default function Faturamento({ onDataLoad, onRealizadoLoad, valorMeta, refreshSignal }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const base_url = 'https://onboard.fck.ind.br';

  const fetchData = useCallback(async () => {
    const token = localStorage.getItem('@user_token');

    if (!token) {
      setLoading(false);
      return;
    }

    fetch(`${base_url}/api/dashboard/Faturamento`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`Erro HTTP: ${res.status}`);
        }
        return res.json();
      })
      .then(json => {
        const result = Array.isArray(json) ? json[0] : json;
        setData(result);

        if (result?.valor_devolucoesMes && onDataLoad) {
          onDataLoad(result.valor_devolucoesMes);
        }
        if (result?.valor_Total && onRealizadoLoad) {
          onRealizadoLoad(result.valor_Total);
        }
         console.log("Dados de faturamento atualizados.");
        
      })
      .catch(err => {
        console.error("Erro ao carregar faturamento:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [onDataLoad ,onRealizadoLoad]);

   useEffect(() => {
         fetchData();
       }, [fetchData, refreshSignal]);
   
  if (loading) {
    return (
      <div className="bg-[#161b22] border-l-4 border-green-500 p-5 rounded animate-pulse h-[180px]">
        <div className="h-4 bg-gray-800 rounded w-1/2 mb-4"></div>
        <div className="h-8 bg-gray-800 rounded w-3/4"></div>
      </div>
    );
  }

  return (
    <>
      <StatBox
        title="FATURAMENTO"
        icon={LayoutDashboard}
        color="text-green-400"
        border="border-green-500"
        dia={data?.valor_totalDia || data?.Valor_TotalDia || 0}
        mes={data?.valor_Total || data?.valor_Total || 0}
        hasMeta={true}
        metaVal={data?.valor_Total / valorMeta * 100}
        //{data?.percentualMeta || 0}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <FaturamentoTotal 
          data={data} 
          onClose={() => setIsModalOpen(false)} 
        />
      )}
    </>
  );
}